const about = {
    metaTitle: 'About',
    metaDescription:
      'Founder-led profile of Oreste Twizeyimana: backend engineer with production .NET experience, mechatronics-shaped systems thinking, and strong communication skills.',
    eyebrow: 'Founder Profile',
    title: 'The engineer behind Oracle Consults',
    lead:
      'This practice is founder-led because the strongest asset behind it is not a broad agency identity. It is a specific combination of production backend delivery, systems thinking, and clear communication built over real work.',
    intro: [
      'The strongest stable reading across the evidence is not generic developer. It is production backend engineer, systems thinker, tutor, and builder of software tied to real operational problems.',
      'That matters because the consulting offer on this site is not marketing invention. It is a compressed version of what the underlying work history, projects, and profile consistently support.'
    ],
    quickFactsTitle: 'At a glance',
    quickFacts: [
      'Based in Bydgoszcz, Poland, and open to remote, hybrid, and relocation-friendly collaboration.',
      'Commercial core: C#, .NET, ASP.NET Core, EF Core, SQL Server, integrations, testing, and production support.',
      'Expansion space: Python, FastAPI, Flask, automation, diagnostics, and device-aware tooling.',
      'Differentiators: mechatronics, multilingual communication, tutoring, and systems thinking.'
    ],
    sections: [
      {
        title: 'What makes the profile distinctive',
        paragraphs: [
          'A lot of early-career developers have one or two good signals. This profile combines real backend production experience, a serious thesis tied to a real business problem, meaningful Python range, and unusually strong communication.',
          'The result is a consultant who can handle technical detail without losing the business problem or the human side of delivery.'
        ]
      },
      {
        title: 'Why operational software keeps showing up',
        paragraphs: [
          'The strongest personal through-line comes from direct exposure to small-business inventory and workflow problems. That is why the work keeps coming back to stock, reservations, reporting, automation, and systems that reduce manual friction.',
          'It is practical empathy more than abstract fascination: software should make complicated operations more dependable for the people who run them.'
        ]
      },
      {
        title: 'Commercial foundation',
        paragraphs: [
          'The commercial center of gravity is Oponeo.pl, where the work repeatedly points to ASP.NET Core APIs, EF Core, SQL Server, payment and logistics integrations, performance tuning, legacy refactoring, Agile delivery, testing, and production support.',
          'That experience matters because it proves the ability to work inside systems with real traffic, dependencies, and operational consequences.'
        ]
      },
      {
        title: 'Mechatronics and systems thinking',
        paragraphs: [
          'Computer engineering and mechatronics reinforce a style of thinking based on integration, measurement, reliability, control, constraints, and failure modes.',
          'In backend consulting, that translates into stronger architectural judgment, more careful reasoning about boundaries, and better instinct for how systems behave under real pressure.'
        ]
      },
      {
        title: 'Communication and teaching',
        paragraphs: [
          'Programming tutoring and language teaching are not side notes. They strengthen decomposition, clarity, patience, and the ability to adapt an explanation to the audience in front of me.',
          'That makes collaboration easier for clients, founders, product people, and engineers who all need a shared view of what the system is doing and why.'
        ]
      }
    ],
    valuesTitle: 'Working style',
    values: [
      'Analytical: I look for causes, dependencies, constraints, and failure modes rather than only feature output.',
      'Practical: I prefer work tied to operations, reporting, workflows, integrations, and visible business usefulness.',
      'Quality-oriented: SOLID, clean architecture, testing, CI/CD, and documentation are part of delivery, not decoration.',
      'Adaptable: I can move across .NET, Python, tutoring, automation, and platform work without losing the same core identity.'
    ],
    directionTitle: 'Direction',
    direction: [
      'Backend and platform work in technically demanding product environments.',
      'Business systems and operational platforms where reliability matters.',
      'Python tooling, automation, and service-oriented backend work.',
      'Security-aware and diagnostics-oriented backend engineering as a growth edge.'
    ],
    practiceNote:
      'Founder-led backend consulting for operational software. Based in Bydgoszcz, Poland. Available remotely across Europe and internationally.',
    closing:
      'The center of the profile is not simply I like coding. It is closer to this: I want to make complicated systems work reliably for real people.'
  };

export default about;
